import { loadApps } from './utility';
import Axios from './axios-instance';
import Cookies from 'js-cookie';

if (
    Cookies.get('refresh_token') &&
    Cookies.get('client_id') &&
    Cookies.get('org_id') &&
    Cookies.get('member_id') &&
    Cookies.get('pool_id') &&
    Cookies.get('genericServerUrl') &&
    Cookies.get('domainServerUrl') &&
    Cookies.get('token')
) {
    Axios.refreshToken()
        .then((response) => {
            let config = response;
            config.token = Cookies.get('token');
            config.clientIdInUse = Cookies.get('client_id');
            config.pool = {
                id: Cookies.get('user_pool'),
            };
            config.poolId = Cookies.get('pool_id');
            config.orgId = Cookies.get('org_id');
            config.member = Cookies.get('member_id');
            config.baseUrl = Cookies.get('genericServerUrl');
            config.org = localStorage.getItem('org_name');
            config.roles = JSON.parse(localStorage.getItem('roles'));
            let defaultApp = localStorage.getItem('default-app') || '/vms-v4';
            Axios.createInstance(
                config,
                window.location.pathname === '/' || window.location.pathname.includes('/login') ? defaultApp : window.location.href,
            );
        })
        .catch((error) => {
            Cookies.remove('refresh_token', {
                expires: 1,
                domain: '.veris.in',
                secure: true,
            });
            loadApps(['login'], (pathname) => {
                return '/login';
            });
        });
} else {
    loadApps(['login'], (pathname) => {
        if (window.location.href.includes('/login')) {
            return window.location.href;
        } else {
            return '/login';
        }
    });
}
